import {
  MAX_DAPP_NAME_LENGTH,
  MAX_EDITORS_CHOICE_HEADLINE_LENGTH,
  MAX_EDITORS_CHOICE_TAG_LENGTH,
  MAX_SUBTITLE_LENGTH,
  MIN_PREVIEW_IMAGES,
} from '../../../../constants/form';
import type { FormState } from '../types';

export function createEmptyFormState(): FormState {
  return {
    dappName: '',
    packageName: '',
    subtitle: '',
    description: '',
    dappIcon: null,
    banner: null,
    dappPreviews: Array(MIN_PREVIEW_IMAGES).fill(null),
    editorsChoiceHeadline: '',
    editorsChoiceTag: '',
    editorsChoiceGraphic: null,
    languages: ['en-US'],
    availableCountries: [],
    availableCountriesMode: 'include',
    appWebsite: '',
    contactEmail: '',
    supportEmail: '',
    tokenDistribution: false,
    walletAddress: '',
    licenseUrl: '',
    privacyPolicyUrl: '',
    releaseApprovalMode: 'Automatic',
  };
}

export function applyTextInputLimit(name: string, value: string): string {
  if (name === 'dappName' && value.length > MAX_DAPP_NAME_LENGTH) {
    return value.slice(0, MAX_DAPP_NAME_LENGTH);
  }

  if (name === 'subtitle' && value.length > MAX_SUBTITLE_LENGTH) {
    return value.slice(0, MAX_SUBTITLE_LENGTH);
  }

  if (
    name === 'editorsChoiceHeadline' &&
    value.length > MAX_EDITORS_CHOICE_HEADLINE_LENGTH
  ) {
    return value.slice(0, MAX_EDITORS_CHOICE_HEADLINE_LENGTH);
  }

  if (
    name === 'editorsChoiceTag' &&
    value.length > MAX_EDITORS_CHOICE_TAG_LENGTH
  ) {
    return value.slice(0, MAX_EDITORS_CHOICE_TAG_LENGTH);
  }

  return value;
}

export function hasFormChanges(
  formData: FormState,
  initialData: FormState | null,
): boolean {
  if (!initialData) {
    return false;
  }

  const hasTextChanges =
    formData.dappName !== initialData.dappName ||
    formData.packageName !== initialData.packageName ||
    formData.subtitle !== initialData.subtitle ||
    formData.description !== initialData.description ||
    JSON.stringify(formData.languages) !==
      JSON.stringify(initialData.languages) ||
    formData.availableCountriesMode !== initialData.availableCountriesMode ||
    JSON.stringify(formData.availableCountries) !==
      JSON.stringify(initialData.availableCountries) ||
    formData.appWebsite !== initialData.appWebsite ||
    formData.contactEmail !== initialData.contactEmail ||
    formData.supportEmail !== initialData.supportEmail ||
    formData.tokenDistribution !== initialData.tokenDistribution ||
    formData.walletAddress !== initialData.walletAddress ||
    formData.licenseUrl !== initialData.licenseUrl ||
    formData.privacyPolicyUrl !== initialData.privacyPolicyUrl ||
    formData.editorsChoiceHeadline !== initialData.editorsChoiceHeadline ||
    formData.editorsChoiceTag !== initialData.editorsChoiceTag ||
    formData.releaseApprovalMode !== initialData.releaseApprovalMode;

  const hasFileChanges =
    formData.dappIcon !== null ||
    formData.banner !== null ||
    formData.editorsChoiceGraphic !== null ||
    formData.dappPreviews.some((preview) => preview !== null);

  return hasTextChanges || hasFileChanges;
}
